import React, { useState, useEffect, Fragment } from "react";
import axiosConfig from "../../services/axiosConfig";
import SweetAlert from 'sweetalert2';
import setHeader from "../../components/Functions/setHeader";
import LoadingComponent from "../../components/common/LoadingComponent";

const ManageCurrency = () => {
    const [currencies, setCurrencies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        setCurrencies([]);

        axiosConfig.get("currency-list", setHeader())
            .then((res) => {
                if (res.data.data && res.data.data.length > 0) {
                    setCurrencies(res.data.data);
                    const activeCurrency = res.data.data.find(c => c.active_status === "1");
                    if (activeCurrency) {
                        setSelectedCurrency(activeCurrency.c_id);
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching currencies:", error);
                SweetAlert.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to fetch currency data.',
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCurrencyChange = (currencyId) => {
        setSelectedCurrency(currencyId);
    };

    const updateCurrencyStatus = () => {
        if (!selectedCurrency) return;

        setUpdating(true);
        
        const params = { c_id: selectedCurrency };

        axiosConfig.post("update-currency-status", params, setHeader())
            .then(() => {
                SweetAlert.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Currency status updated successfully.',
                    timer: 2000,
                    showConfirmButton: false
                });
                getData(); 
            })
            .catch((error) => {
                console.error("Error updating currency:", error);
                SweetAlert.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to update currency status.',
                });
            })
            .finally(() => {
                setUpdating(false);
            });
    };

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mt-30" style={{ marginTop: '2rem' }}>
                            <div className="card-header p-3">
                                <h5 className="card-title mb-0">
                                    <i className="fa fa-money me-2"></i>
                                    Manage Currency
                                </h5>
                            </div>
                            <div className="card-body">
                                {currencies.length > 0 ? (
                                    <>
                                        <div className="row">
                                            {currencies.map((currency) => (
                                                <div key={currency.c_id} className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="currency"
                                                            id={`currency_${currency.c_id}`}
                                                            checked={selectedCurrency === currency.c_id}
                                                            onChange={() => handleCurrencyChange(currency.c_id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`currency_${currency.c_id}`}>
                                                            {currency.currency} ({currency.symbol})
                                                        </label>
                                                        <small className="text-muted ms-2">
                                                            ({currency.active_status === "1" ? "Active" : "Inactive"})
                                                        </small>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <hr />
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div></div>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={updateCurrencyStatus}
                                                            disabled={updating}
                                                        >
                                                            {updating ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                    Updating...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa fa-save me-1"></i>
                                                                    Update Currency
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-center py-5">
                                        <i className="fa fa-info-circle text-muted" style={{ fontSize: '3rem' }}></i>
                                        <h5 className="mt-3 text-muted">No currency data available</h5>
                                        <p className="text-muted">Please check your connection and try again.</p>
                                        <button 
                                            className="btn btn-primary"
                                            onClick={getData}
                                        >
                                            <i className="fa fa-refresh me-1"></i>
                                            Retry
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ManageCurrency;
